export const GENERATED_IDS = {
    "__MODIFIER_ID": {
      "MASTERS_CALL": "068f6ed7-c9ef-413e-a447-f7d779ad9aa1"
    },
    "__SPELL_ID": {
      "DH": {
        "HAVOC": {
          "DARKNESS": "9ba548ea-fc82-4d61-9b01-3cde12d48716"
        },
        "VENG": {
          "DARKNESS": "e4351f7c-0801-42d7-ba5c-22b53dbe7b63"
        }
      },
      "DK": {
        "BLOOD": {
          "ABOM_LIMB": "41702c8c-996b-4e69-aabe-fb6a9af6b7bf",
          "AMZ": "e04f6bed-54d6-4ccd-b284-fd5302e98106",
          "GRASP": "e793cd57-8d6b-450d-922f-b7f8ecdaccde"
        },
        "FROST": {
          "ABOM_LIMB": "de825485-2096-4c97-ac2f-b6d52a890970",
          "AMZ": "218ec9c8-14a5-4e52-821b-30e701619ebd"
        },
        "UNHOLY": {
          "ABOM_LIMB": "743faca6-fb16-43a3-90b7-0362bbb0145f",
          "AMZ": "279e6146-898b-482f-9b99-a74845c191ac"
        }
      },
      "DRUID": {
        "BALANCE": {
          "INNERVATE": "2ab4cecf-5bbc-4af0-b1e6-136266ac36eb",
          "ROAR": "b594d808-ad9d-441b-9f63-35d573a6f708",
          "VIGIL": "9e2c4cba-a1df-4717-bf0f-452654fc4903",
          "VORTEX": "c5f94a83-5f36-4eee-98c3-188b3d977604"
        },
        "FERAL": {
          "INNERVATE": "01c21fba-6d03-4334-a79a-d34aa45baec4",
          "ROAR": "fa3e4f83-f25b-4123-aec6-5f3585937938",
          "VIGIL": "8f42a93f-7c02-426f-8096-4278e67a6cd7",
          "VORTEX": "e9f4a649-58c3-48e2-b922-61319b1a97d8"
        },
        "GUARDIAN": {
          "INNERVATE": "7b184ca9-113a-44d8-8be1-a658db10155e",
          "ROAR": "1fd3f0ec-fcfa-47d2-931d-1046f41aacd8",
          "VIGIL": "b781e71d-7f4c-4ca1-981b-65a56154555d",
          "VORTEX": "17336c8c-6723-44ee-a7e0-07d77f97f207"
        },
        "RESTO": {
          "CONVOKE": "462666f3-b5f0-4dd0-806c-58d95be98dda",
          "IRONBARK": "ec902111-72bb-4274-9d26-ac9e525cdba3",
          "ROAR": "aeba0c47-70cf-4fd4-a69e-785cb2e608b7",
          "TRANQ": "addb8673-43ef-48e5-b6d2-d8bb92bb4cdd",
          "TREE": "b844ccd9-91d9-4c22-90a6-53ecb5fe87be",
          "VORTEX": "784675e5-92e8-4ec6-96cb-792cad54ce1a"
        }
      },
      "EVOKER": {
        "AUG": {
          "RESCUE": "86c5ede8-4b3a-453e-a30d-7217ac216ddc",
          "SPAT_PARADOX": "71ed0b6b-d352-4366-aa9a-526fe005f36a",
          "SPIRAL": "82948bc5-557a-4406-9c79-58b549ad61c0",
          "ZEPHYR": "15de70ab-5f4d-4d2a-81fc-bcbd6f25943f"
        },
        "DEVA": {
          "RESCUE": "e808a728-ffb6-4144-b3de-3814260fdb3e",
          "SPAT_PARADOX": "2bf63906-ceab-45aa-8244-82b8b2f40fa4",
          "SPIRAL": "f7710243-7665-432d-af2a-565c91498eb1",
          "ZEPHYR": "e2008809-fa49-45f5-88cc-69d69f09d3f7"
        },
        "PRES": {
          "DREAM_FLIGHT": "a7771e1d-ef0b-476b-9364-8f0b6c8b5a74",
          "EM_COM": "141b3ae0-2175-4c92-b384-f7503a15fc2a",
          "RESCUE": "72221d65-18bb-432a-a706-016ea5dd5dc2",
          "REWIND": "e8c809f2-403c-4a1c-931d-3d098d0b4be4",
          "SPAT_PARADOX": "e3e67a81-8897-4358-a78e-a9d2f4a052f4",
          "SPIRAL": "0be1c70c-7f60-4a80-b494-6c6c02ce1256",
          "TIME_DIALATION": "a96abc8d-2053-4c85-ad04-86337dbee19e",
          "ZEPHYR": "4f0bef06-d8f2-4edf-aa0d-03b071ad0ad9"
        }
      },
      "HUNTER": {
        "BM": {
          "MASTERS_CALL": "4e56230b-e5a3-4799-8429-a08086373c1e",
          "TURTLE": "42339fbf-de98-4081-a66b-68958bcb3246"
        },
        "MM": {
          "MASTERS_CALL": "a72746bd-e803-49a0-9563-7aa61ba66a4e",
          "TURTLE": "354aaa0a-f46d-4cea-9226-7a9be0c05723"
        },
        "SV": {
          "MASTERS_CALL": "57aa024a-6536-49c2-aa2a-12c61ce500de",
          "TURTLE": "ad2ca623-1ce1-4436-ad84-68766ef45c35"
        }
      },
      "MAGE": {
        "ARCANE": {
          "HPPOT": "77acb516-6b8f-41fb-986c-a27fec78a268",
          "HS": "d1cb7755-045b-42d3-b61d-1e77bf93e2ab",
          "MASS_BARRIER": "101a477e-6c15-4737-a6f7-6c1a160af6a3",
          "PERSONAL2MIN": "a22311c6-51f4-4e91-91b7-84714dad3732"
        },
        "FIRE": {
          "MASS_BARRIER": "4bae75e8-50ef-492c-96a2-c3287a54768d"
        },
        "FROST": {
          "MASS_BARRIER": "0c684f02-ff97-4423-b2b4-e49f80ce337e"
        }
      },
      "MONK": {
        "BRM": {
          "SWEEP": "22d28f2e-4543-4754-a890-a76d3a49a548",
          "TIGERS_LUST": "5070b303-2953-4a55-bb51-a0bd8344fe09"
        },
        "MW": {
          "CHI_JI": "326c88a3-2bb1-45a0-994d-c3b781466600",
          "COCOON": "329084ee-be01-401d-973a-ac2b7d2e2045",
          "REVIVAL": "8f757123-5b98-46e4-970f-99c5107dce72",
          "SWEEP": "6cd93bbd-5d10-4f8e-9df8-1b5a484f39c9",
          "TIGERS_LUST": "56a8ac4a-31a5-48d6-837b-3bd7af64691f",
          "YULON": "251895f0-3d43-4ec5-92c7-f2063b0b9664"
        },
        "WW": {
          "SWEEP": "47dca887-ece0-458e-a98d-6ac8dc58a775",
          "TIGERS_LUST": "1a034bc0-02b1-4222-bd49-abdbd49de23c"
        }
      },
      "PALADIN": {
        "HOLY": {
          "AM": "a75f53b3-76f6-47bd-98f2-94213cd65a4f",
          "AVENGING_WRATH": "3c83d513-533d-492d-9bef-0623db138049",
          "BLESS_SAC": "713c29b6-5bdb-4796-b376-3bde75ae6b4b",
          "BOP": "a951b8ac-cb01-4f01-a0f8-38df076bf301",
          "CRUSADER": "5fddf206-784d-4f84-9237-7bb80cc15ab7",
          "DIVINE_TOLL": "5ee6a82a-ebcc-45d6-8e3d-9668f9b1e059",
          "DIV_SHIELD": "d1e7f489-2653-4e4c-a515-30c7a5276797",
          "FREEDOM": "c90b5bf9-7ffc-47d8-b376-ba72186e25b3",
          "TYR_DELIVERANCE": "2d5f4ca4-50ce-4b63-82f6-608e243750b3"
        },
        "PROT": {
          "BLESS_SAC": "b2e25425-b989-437e-aca8-e62156f9ba65",
          "BOP": "1012c0a1-b2b4-4176-94a9-d47d198e21c3",
          "DIV_SHIELD": "77116d42-1a38-41f5-a655-e8757ef0428e",
          "FREEDOM": "ecbd7b52-095c-4235-ba4f-cac68ed81f07",
          "SPELLWARDING": "42156402-c5f5-4b2e-91e4-531189825a47"
        },
        "RET": {
          "BLESS_SAC": "24b79c04-7217-492e-aca6-4500fa80124c",
          "BOP": "38fd80ac-1990-4a29-845f-622648797f07",
          "DIV_SHIELD": "f9c6752f-572b-4279-a184-2ebb993610b6",
          "FREEDOM": "cb77a43e-809f-4e05-84ad-9c81db717cd7"
        }
      },
      "PRIEST": {
        "DISC": {
          "BARRIER": "1ee4bd80-9de9-49cd-94c4-93e1b64de6d4",
          "BENDER": "d6c91c73-29d6-4f19-924a-ac4c629e7ac0",
          "EVANG": "9a9918e7-a2f8-4a5c-a8fa-9e8698ab05dd",
          "FIEND": "0068e949-b039-4f31-b7de-b63aff00e4e5",
          "LEAP_OF_FAITH": "34515fa9-70f9-4a82-ba89-262b8d67c19d",
          "MASS_DISPEL": "0ede88ec-4877-4d9e-aee2-6d9d71055425",
          "PAINSUP": "ab58a974-2629-4cb5-8248-ebe20b7074ab",
          "POWER_INFUSION": "3599c0ce-cfa3-4434-b1c8-7e2987ac9de9",
          "ULTI_PEN": "9a95da74-4439-407b-a567-97c3591eac6d"
        },
        "HOLY": {
          "APO": "7b7df88f-fcdd-486d-9100-d715c05465b3",
          "GUARDIAN_SPIRIT": "27d704f8-5e10-4186-93ad-04fb65934e68",
          "HYMN": "dd8fb0eb-9eb6-409b-8273-3c385272cdd1",
          "LEAP_OF_FAITH": "417ea2a4-0137-408f-b136-de37029b6f02",
          "MASS_DISPEL": "cea5efd9-784b-4905-aa57-877f6c079224",
          "POWER_INFUSION": "565c4ff6-e96a-476e-a391-782820dfde80",
          "SYMBOL_OF_HOPE": "df390fec-d40e-440c-95d6-b1674dd93db2"
        },
        "SHADOW": {
          "LEAP_OF_FAITH": "25555cd2-b57a-42c1-80ff-98d9025d59a1",
          "MASS_DISPEL": "c93d1c28-2dae-4e36-a5a0-cea6186e46e8",
          "VAMP_EMBRACE": "ed3afda4-ab7a-4d18-8768-197c47df876c"
        }
      },
      "ROGUE": {
        "ASS": {},
        "OUT": {},
        "SUB": {}
      },
      "SHAMAN": {
        "ELE": {
          "RECALL": "f1ce058f-96aa-412b-a8da-14fc74d5c6f8",
          "WRT": "1d81f543-080f-4afa-8232-35b3c41450a7"
        },
        "ENH": {
          "RECALL": "735fc594-57f3-413c-8000-8ea8aeb3a20e",
          "WRT": "ab2775c2-9bde-4a82-bece-734c34331605"
        },
        "RESTO": {
          "APT": "5591738a-9f04-4847-9437-dbfdbc6fedf3",
          "ASC": "dad553bd-8fd7-424f-aec1-2deb23df82d1",
          "HTT": "a86cff5e-78d8-4e88-8415-e2455108e044",
          "MTT": "fd916eb4-325b-407a-88bf-0edf172a5e76",
          "RECALL": "030b5e2c-d6ff-4998-84d5-9f90184dfab2",
          "SLT": "9d80835a-52b9-4d35-a86b-576000445c02",
          "WRT": "e8db7730-679d-4b50-947c-73256902fb94"
        }
      },
      "WARLOCK": {
        "AFFLI": {},
        "DEMO": {},
        "DEST": {}
      },
      "WARRIOR": {
        "ARMS": {
          "RALLY": "fedce7ea-cda3-412e-84ba-1e9a5f98a996"
        },
        "FURY": {
          "RALLY": "5a29401a-fc11-4cfd-8ea2-3ffd2bc73a05"
        },
        "PROT": {
          "RALLY": "1260da03-81c4-41cc-a693-addcd98c067f"
        }
      }
    },
    "__TALENT_ID": {
      "DH": {
        "HAVOC": {
          "DARKNESS": "21fbcd60-b5fa-4da4-ba8f-323f142dcecf",
          "PITCH_BLACK": "e9241746-c3b9-48f3-8f59-3e44529f8c44"
        },
        "VENG": {
          "DARKNESS": "942880fa-5ba3-4a7e-9fc7-66f0c1eaa773",
          "PITCH_BLACK": "56c44c32-56d3-4b05-b190-d081d7d92887"
        }
      },
      "DK": {
        "BLOOD": {
          "ABOM_LIMB": "ddf5e9b4-563c-489c-9e2c-969ef9137d90",
          "ASSIMILATION": "a1a9d9f5-3e80-42d8-a698-790f5483e233",
          "GRASP": "ef60d47b-0057-4d36-b70e-2da0c78f7f60",
          "TIGHT_GRASP": "6e4d7e5b-8a41-4dae-aca0-5ba062d951f9"
        },
        "FROST": {
          "ABOM_LIMB": "29c3a6b1-c239-4c62-8cbc-17851246f2ca",
          "ASSIMILATION": "b20ce071-7803-4516-987a-fa837638ecc5"
        },
        "UNHOLY": {
          "ABOM_LIMB": "d51b0c37-a48f-4c9c-ab59-5056cccd2c97",
          "ASSIMILATION": "1db88ec3-6ff2-45a0-9d6d-3f6565666ec5"
        }
      },
      "DRUID": {
        "BALANCE": {
          "IMPROVED_ROAR": "816c9398-85be-4d6d-b2ff-9e47a9a5a259",
          "INNERVATE": "6467fbd3-c882-4737-a3b0-eb61173588d0",
          "VIGIL": "92a8ac6f-8d82-497b-a7be-8cb4dfc35493",
          "VORTEX": "19b8b476-3bf6-4ea2-8c39-78421f6a4c42"
        },
        "FERAL": {
          "IMPROVED_ROAR": "583c8125-aa0f-4233-b00e-148483c8f430",
          "INNERVATE": "69827ab3-42ef-4913-a09e-b923d37bf960",
          "VIGIL": "23a727ed-218c-4d15-ab63-59c52a812cc3",
          "VORTEX": "c50dc21e-810f-40a8-b0d3-2253e8bb292f"
        },
        "GUARDIAN": {
          "IMPROVED_ROAR": "7d92941f-be8d-4993-a845-2787dbd3e8e3",
          "INNERVATE": "54a7aa89-b5e0-47c4-923f-553cce4af783",
          "VIGIL": "0ed2857e-162c-4655-a874-0e1bd27d580c",
          "VORTEX": "32afdfd0-fcbc-42b7-aa73-d5a0a182c250"
        },
        "RESTO": {
          "CEN_GUIDANCE": "7aa9aea3-7f0e-4875-9ef6-04e6ccabcfde",
          "CONVOKE": "a850f1e4-51d9-4019-93a6-1d2fbc9b07f3",
          "IMPROVED_ROAR": "68c4840d-d722-4111-9259-d609d2a47a8d",
          "IMPR_IRONBARK": "b8dd12bc-a02a-4619-b322-a3443f2ae2c7",
          "INNER_PEACE": "276404dc-75ba-4a51-ab87-e243c200c27c",
          "TREE": "e7212970-f5d7-4249-80a0-a32a19a13c9a",
          "VORTEX": "20669b18-9b9c-4a70-8897-7d2d78dbbd9c"
        }
      },
      "EVOKER": {
        "AUG": {
          "RESCUE": "62c3849f-7ce6-49b0-878c-3ffd80cc0cfa",
          "SPAT_PARADOX": "a53276ad-cac3-4b9c-8d1f-a0799aa72517",
          "SPIRAL": "3ff77a62-6e49-4f1b-a57e-633531b12d51",
          "ZEPHYR": "7010c6b1-7294-42c2-83f9-41a824dd50b3"
        },
        "DEVA": {
          "RESCUE": "d12ab590-e070-4499-a46b-8f8d9f6d87f9",
          "SPAT_PARADOX": "db125588-e68c-4063-9294-3b24618a0e06",
          "SPIRAL": "cac23db6-fdaa-4d74-874f-ef7e48f654a3",
          "ZEPHYR": "a7e35d51-0b24-459f-a910-3c171a1f1c2c"
        },
        "PRES": {
          "DREAM_FLIGHT": "69be9306-608e-4446-be1e-cc51ea80988d",
          "EM_COM": "3725d5f9-9f0d-4247-b601-593641f2b400",
          "ERASURE": "b1e5d8b2-8f03-4c56-87bc-168b78983f05",
          "RESCUE": "c788d9cb-8e85-432b-8ec4-763fc36d75bd",
          "SPAT_PARADOX": "b1b64ce1-49d1-4fa5-b047-fc83e85a6f49",
          "SPIRAL": "e0ed8a5e-e384-490e-bae8-b0bbe94ccf3f",
          "TEMPORAL_ARTIFICER": "60d405ec-59b6-412a-930e-ae796cc44bab",
          "ZEPHYR": "d3313379-f52e-4693-8d02-2ff8414771e2"
        }
      },
      "HUNTER": {
        "BM": {
          "BORN_TO_BE_WILD": "feafa380-c709-4caf-8764-32653034cacd"
        },
        "MM": {
          "BORN_TO_BE_WILD": "0681053e-7a87-42d2-bbb6-3040dec74a0f"
        },
        "SV": {
          "BORN_TO_BE_WILD": "5ae9580e-cb49-4e4f-aa6d-9d17c56aaf38"
        }
      },
      "MAGE": {
        "ARCANE": {
          "HPPOT": "85054271-9346-4fb8-befb-d630584f60d8",
          "HS": "6923f864-ad8f-4925-9a84-070df62696f7",
          "MASS_BARRIER": "1ef6a0a8-330f-4ae0-b6ac-b16ff8175985",
          "PERSONAL2MIN": "e18bbe7e-148c-4b9a-b04b-4e55e3bde3af"
        },
        "FIRE": {
          "MASS_BARRIER": "07cab4a9-2332-45e0-a119-728f2fa001ad"
        },
        "FROST": {
          "MASS_BARRIER": "2ac4e358-e222-4c2e-81ea-67d0a1878997"
        }
      },
      "MONK": {
        "BRM": {
          "ANCIENT_ARTS_1": "0664d053-620c-4a9a-8b81-b5708d613ecd",
          "ANCIENT_ARTS_2": "b46075fb-d3c3-4057-82ee-936233ed4ab1"
        },
        "MW": {
          "ANCIENT_ARTS_1": "57257465-dc2e-4329-8aa5-654ab01cafdd",
          "ANCIENT_ARTS_2": "f4826595-8556-48d2-bd8d-1d65d16cfb10",
          "CHI_JI": "43e9d1e3-6222-49a9-885d-e5ef18895d51",
          "CHRYS": "697468b8-0ac6-4eac-a025-e2c8add98f9a",
          "GIFT_OF_CELEST": "c4fb1719-67a6-40f5-89ed-d11eb98a97f8",
          "TIGERS_LUST": "a1190285-e0a2-484c-9471-d4244f4709b9",
          "YULON": "85688f8c-a893-4da2-8ddd-95440e3ca0f5"
        },
        "WW": {
          "ANCIENT_ARTS_1": "bff86c49-be3e-4c8e-98da-39165ff143cf",
          "ANCIENT_ARTS_2": "536d0677-f2da-4049-a994-781dc6f0fdb5",
          "TIGERS_LUST": "7ed586dd-19c5-46e7-be0e-0bd9b4564584"
        }
      },
      "PALADIN": {
        "HOLY": {
          "AVENGING_WRATH": "d635d8b8-1c98-41c9-8ee2-67f9e427b23c",
          "BOP": "3a8b4082-7e3f-4769-9aef-0afb0c6218c0",
          "CRUSADER": "13c1b475-07ae-47ae-8c40-f8f6e8c65b80",
          "DIVINE_TOLL": "0b20bfaa-6d9b-4d48-82ab-91e8bfa0a0ae",
          "IMP_BLESSING": "3bb079c8-2c07-4ae3-916f-b613cd94dce0",
          "QUICK_INVO": "99080003-2bd8-4434-8cf0-06dfc5c689b6",
          "SAC_JUST": "4c69476f-cbfc-4ab4-90c4-77d7994672b3",
          "TYR_DELIVERANCE": "a107c2ad-9fb6-494b-bb2d-9e3eb65ae4ea",
          "UNBREAK_SPIRIT": "b6b61f4c-5577-457a-bf54-3547661a4dce",
          "UNWAVERING_SPIRIT": "fbed7388-e41a-4a31-9c97-6f4aa5fbec72"
        },
        "PROT": {
          "BLESS_SAC": "f2af9c45-0654-4dea-bbff-1f1272279129",
          "BOP": "bb8c6b1f-9882-4de1-ba3a-a336b3e2f83e",
          "COUNSEL_1_2": "fbd06f55-71cc-422f-b03e-8b1a2bb50980",
          "COUNSEL_2_2": "08934f1c-beda-433f-aa24-8c7056f190de",
          "FREEDOM": "29e5b934-702a-49b8-896a-3bae79e4570c",
          "IMP_BLESSING": "9af98e94-57d6-442f-b31d-8481dc960391",
          "SAC_JUST": "1ad4605f-1098-4c6c-96ee-dad6e503dbfa",
          "UNBREAK_SPIRIT": "aaac0711-6e84-472b-a1c1-652c8f833c60"
        },
        "RET": {
          "BLESS_SAC": "e30f64db-ddce-4fee-8770-e0db405b5e02",
          "BOP": "bf99cae6-ff7b-4020-83c5-01405fe3869f",
          "IMP_BLESSING": "c5c5d3c7-4bb0-45d7-b7e7-13d3b945a3fd",
          "SAC_JUST": "5e19c74d-51bf-4a6c-b4ae-4062092545c7",
          "UNBREAK_SPIRIT": "9d3e0934-fd24-4548-8e98-24b15b3a7724"
        }
      },
      "PRIEST": {
        "DISC": {
          "BENDER": "86a57591-e264-4ff6-8343-effad90ccf46",
          "LEAP_OF_FAITH": "dbd77078-c13d-4698-9837-255c458b30dd",
          "MASS_DISPEL": "55d279c4-3b32-48bc-afe6-fba03504e6f8",
          "MOVE_WITH_GRACE": "ee0197a0-eea0-4861-a223-c460b28c64a7",
          "POWER_INFUSION": "785b2684-c8e9-49d8-bc0d-345e37f22848",
          "ULTI_PEN": "abdf54fd-3107-4769-a046-45fc47709cf8"
        },
        "HOLY": {
          "APO": "47a49203-fab9-45e1-83f9-8e8d05610884",
          "GUARDIAN_ANGEL": "12c8bd27-583f-4962-a64e-1e679884f2ba",
          "GUARDIAN_SPIRIT": "2f0bd1e5-b6a6-4f22-9eb5-b7cc2764e42d",
          "LEAP_OF_FAITH": "2748443f-7a4b-4590-8247-f2a1e8012497",
          "MASS_DISPEL": "60239fe4-730f-4e48-b76a-b6dfcf2e849c",
          "MOVE_WITH_GRACE": "5bfef2d9-ac8d-4ab7-8130-c189613aecf5",
          "POWER_INFUSION": "3a9532a9-1628-48e5-bfa5-6c86f01e984b",
          "SERAPHIC": "ac6a2554-4ca1-4af8-9470-a7c35bc006b4"
        },
        "SHADOW": {
          "LEAP_OF_FAITH": "e4110ee3-e5be-4e09-aa25-e580a7b09d97",
          "MASS_DISPEL": "86967fd5-a1d9-4a28-95ba-4726fbd78e88",
          "MOVE_WITH_GRACE": "34f9cd41-943d-4938-b700-487a4ae91dc6",
          "SANLAYN": "ec0aae17-7c9c-4335-9bbe-54e56e5deb9b",
          "VAMP_EMBRACE": "2b72b7a8-5225-4cf8-9869-e155b771c0ab"
        }
      },
      "ROGUE": {
        "ASS": {},
        "OUT": {},
        "SUB": {}
      },
      "SHAMAN": {
        "ELE": {
          "ASC_AIR": "3132878e-6050-46fa-8123-34b4140cc5a6",
          "CALL_OF_THE_ELEMENTS": "661685eb-b5c8-4805-9a1b-f243c3d7d207",
          "RECALL": "39b7ba4f-f3f1-4c88-9869-2d19d08b6722",
          "TOTEMIC_SURGE": "209202d5-1098-4b82-a57d-c9fb9b2fa3bc",
          "WRT": "b42a618a-6020-4766-8fbb-8427b0589f3e"
        },
        "ENH": {
          "ASC_AIR": "387731b9-c4fd-4f4b-81c5-a5fe97b6ca8e",
          "CALL_OF_THE_ELEMENTS": "23575f08-d1ae-4f0c-89a1-35de86cd38d3",
          "RECALL": "24301623-78be-4acd-90a5-52ebfa22b21e",
          "TOTEMIC_SURGE": "c3460d10-12fa-4f28-a400-8aa45a40c075",
          "WRT": "0443895f-c5d7-4ac4-ae1a-0fc356481c36"
        },
        "RESTO": {
          "APT": "dcc7c4b8-754b-48bf-b32b-f7962a361640",
          "ASC": "d00ae128-a28d-45d4-a73a-933972f4d8e7",
          "ASC_AIR": "323aa9a7-d433-40b0-a1e0-4ec13062af41",
          "CALL_OF_THE_ELEMENTS": "d85b4fbd-e95e-4f19-be78-5060b4ed84dd",
          "CURRENT_CONTROL": "3199ce60-fc5a-401e-a04a-ff6c16d09c8a",
          "FIRST_ASCENDANT": "5ce5c461-8ec9-4c67-84e7-14c9c4a49c91",
          "MTT": "c51067a1-5b8b-4e69-a1fe-fba2b257a695",
          "RECALL": "5f356c9e-aa59-4134-ba94-ba4e0eb365d3",
          "TOTEMIC_SURGE": "c207d1a2-cfde-4750-b925-21ebeb963f95",
          "WRT": "b0609c1f-80fb-4d7e-8575-748119151e7c"
        }
      },
      "WARLOCK": {
        "AFFLI": {},
        "DEMO": {},
        "DEST": {}
      },
      "WARRIOR": {
        "ARMS": {},
        "FURY": {},
        "PROT": {}
      }
    }
  }
